<template>
    <div>
        <!-- <el-row :gutter="24" :v-if="errVisible">
            <el-span :span="24">
                <el-alert
                    title="调试信息"
                    type="info"
                    :description="errDesc"
                    show-icon>
                </el-alert>
            </el-span>
        </el-row> -->
        <el-row :gutter="24">
            <el-col :span="24">
                <el-alert
                    title="正在跳转..."
                    type="info"
                    :description="errDesc"
                    show-icon>
                </el-alert>
            </el-col>
        </el-row>
        
    </div>
</template>

<script>
import { weixinAuth, getJsApiConfig } from '../../api/weixin';
import { getUserByToken,getNavigationBar } from '../../api/api';
import router from '@/router';
import {resetRouter, filterAsyncRouter} from '@/router/index';

export default {
    data () {
        return {
            errVisible: true,
            errDesc: ''
        }
    },
    methods: {
        auth(){
            let _this = this;
            _this.errDesc = `code参数：${_this.$route.query.code}`

            window.localStorage.removeItem('user');
            window.localStorage.removeItem('Token');
            window.localStorage.removeItem('TokenExpire');
            window.localStorage.removeItem('NavigationBar');
            window.localStorage.removeItem('refreshtime');
            window.localStorage.removeItem('router');
            _this.$store.commit("saveToken", "");
            _this.$store.commit("saveTokenExpire", "");

            weixinAuth({ code: _this.$route.query.code }).then(data => {
                if(!data.success){
                    _this.errVisible = true;
                    _this.errDesc = data.msg;
                }else{
                    // _this.getWxConfig();
                    var token = data.response.token;
                    _this.$store.commit("saveToken", token);
                    _this.errDesc = _this.errDesc+`===========> token参数${token}`

                    var curTime = new Date();
                    var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + data.response.expiresIn));
                    _this.$store.commit("saveTokenExpire", expiredate);

                    window.localStorage.refreshtime = expiredate;
                    window.localStorage.expiresIn = data.response.expiresIn;
                    window.localStorage.prefix = "";
                    _this.getUserInfoByToken(token);
                }
                
            });
        },
        getUserInfoByToken(token){
            let _this = this;
            getUserByToken({token: token}).then(data => {
                    if (!data.success) {
                        _this.errDesc = _this.errDesc+'==========>'+data.msg;
                    } else {
                        _this.errDesc = `用户信息获取成功：${data.response}`
                        
                        window.localStorage.user = JSON.stringify(data.response);
                        _this.getNavigationBar(data.response.id);
                    }
                });
        },

        // 获取路由树
        getNavigationBar(uid) {
            var _this = this;
            var loginParams = {uid: uid, t: new Date()};
            _this.errDesc = '正在获取路由树...'
            getNavigationBar(loginParams).then(data => {
                if (!data.success) {
                    _this.errDesc = `路由树获取失败：${data.msg}`;
                } else {
                    _this.errDesc = `路由树获取成功：${data.msg}`;
                    window.localStorage.router = (JSON.stringify(data.response.children));

                    let getRouter = data.response.children//后台拿到路由
                    getRouter = filterAsyncRouter(getRouter) //过滤路由
                    router.$addRoutes(getRouter) //动态添加路由

                    let random = Math.random().toString();
                    _this.$router.push('/mobile/index?v='+random);
                }
            });
        },
    },
    mounted () {
        this.auth();
    }
}
</script>